import { Fragment, useState, type FC } from 'react'
import classNames from 'classnames'
import CountUp from 'react-countup'
import { useInView } from 'react-intersection-observer'

import { Text, Licenses } from 'components'
import { AboutCenterImage } from 'assets'

import AccordionItem from '../Home/Hero/AccordionItem'
import Exhibitions from './Exhibitions'
import styles from './AboutUsPage.module.scss'

// NOTE: placeholder figures grounded in the "more than 10 years" / founded-2013
// copy — confirm the real numbers with the client.
const stats = [
  { end: 12, suffix: '+', label: 'yearsOfExperience' },
  { end: 250, suffix: '+', label: 'projectsDone' },
  { end: 120, suffix: '+', label: 'happyClients' },
  { end: 500, suffix: 'K+', label: 'squareMeter' },
]

const valueItems = [
  { title: 'aboutValueItem1', content: 'aboutValueItem1Desc' },
  { title: 'aboutValueItem2', content: 'aboutValueItem2Desc' },
  { title: 'aboutValueItem3', content: 'aboutValueItem3Desc' },
  { title: 'aboutValueItem4', content: 'aboutValueItem4Desc' },
  { title: 'aboutValueItem5', content: 'aboutValueItem5Desc' },
]

const AboutUsPage: FC = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 })
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <Fragment>
      <section className={styles.hero}>
        <div className={styles.hero__media} aria-hidden>
          <img src={`${process.env.PUBLIC_URL}/aboutUs.png`} alt='' className={styles.hero__image} />
          <div className={styles.hero__overlay} />
        </div>
        <div className={classNames('container', styles.hero__inner)}>
          <Text text='aboutEyebrow' className={styles.hero__eyebrow} />
          <Text text='aboutUs' className={styles.hero__title} tagName='h1' />
          <Text text='whyChooseUsSubtitle' className={styles.hero__subtitle} />
        </div>
      </section>

      <div className={styles.page}>
        <div className={classNames('container', styles.intro)}>
          <div className={styles.intro__text}>
            <span className={styles.intro__accent} aria-hidden />
            <Text text='aboutUsTitle' className={styles.intro__eyebrow} />
            <Text text='aboutUsText' className={styles.intro__paragraph} />
          </div>
          <div className={styles.intro__media}>
            <img src={AboutCenterImage} alt='' className={styles.intro__image} />
          </div>
        </div>

        <section className={classNames('container', styles.stats)} ref={ref} aria-label='Company highlights'>
          {stats.map(stat => (
            <div className={styles.stats__item} key={stat.label}>
              <span className={styles.stats__value}>
                {inView ? <CountUp end={stat.end} duration={2} suffix={stat.suffix} /> : `0${stat.suffix}`}
              </span>
              <Text text={stat.label} className={styles.stats__label} />
            </div>
          ))}
        </section>

        <section className={classNames('container', styles.values)}>
          <div className={styles.values__head}>
            <span className={styles.values__accent} aria-hidden />
            <Text text='aboutValuesTitle' className={styles.values__title} tagName='h2' />
            <Text text='aboutValuesText' className={styles.values__subtitle} />
          </div>
          <div className={styles.values__grid}>
            {valueItems.map((item, index) => (
              <AccordionItem
                key={item.title}
                title={item.title}
                content={item.content}
                isOpen={openIndex === index}
                onToggle={() => setOpenIndex(openIndex === index ? null : index)}
                compact
              />
            ))}
          </div>
        </section>

        <Exhibitions />

        <Licenses />
      </div>
    </Fragment>
  )
}

export default AboutUsPage
